import React, { forwardRef } from 'react';
import { formatColorName } from '../constants/wigOptions';

// The printed worksheet, kept exactly as it was before the on-screen redesign.
// OrderWorksheet renders this hidden and sends its HTML + these styles to the print window.

export const LEGACY_PRINT_STYLES = `
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&display=swap');
          
          @page { 
            margin: 0.4in; 
            size: letter;
          }
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body { 
            margin: 0 !important;
            padding: 0 !important;
            font-family: 'Inter', Arial, sans-serif !important;
            font-size: 11px;
            line-height: 1.3;
            color: #000;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          .no-print { 
            display: none !important; 
          }
          
          .worksheet-container {
            width: 100%;
            max-width: none;
            padding: 0;
          }
          
          /* Header Styles */
          .worksheet-main-header {
            text-align: center;
            margin-bottom: 15px;
            border-bottom: 3px solid #000;
            padding-bottom: 10px;
          }
          
          .company-name {
            font-size: 24px;
            font-weight: 800;
            margin-bottom: 2px;
          }
          
          .worksheet-title {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 8px;
          }
          
          /* Key Info Header */
          .key-info-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          background: white;
          padding: 8px 12px; /* Reduced padding */
          border: 2px solid #000;
          border-radius: 8px;
          gap: 15px; /* Add gap to control spacing */
        }

        .key-info-right {
          display: flex;
          align-items: center;
          gap: 10px; /* Space between QR code and text elements */
        }
                  
          .key-info-left {
            display: flex;
            flex-direction: column;
          }
          
          .customer-name {
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 4px;
          }
          
          .order-number {
            font-size: 18px;
            font-weight: 600;
            color: #333;
          }
          
          .barcode {
            font-size: 16px;
            font-weight: 600;
            font-family: 'Courier New', monospace;
            background:rgb(253, 178, 243);
            color: black;
            padding: 2px 4px;
            border-radius: 4px;
            text-align: center;
            margin-top: 4px;
          }
          
          .due-date {
            font-size: 14px;
            font-weight: 600;
            color: #d63384;
            text-align: right;
          }
          
          /* Quick Info Grid */
          .quick-info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            gap: 10px;
            margin-bottom: 15px;
            font-size: 10px;
          }
          
          .info-item {
            text-align: center;
            padding: 6px;
            border: 1px solid #ddd;
            border-radius: 4px;
            background: white;
          }
          
          .info-label {
            font-weight: 600;
            display: block;
            margin-bottom: 2px;
            font-size: 9px;
            text-transform: uppercase;
            color: #666;
          }
          
          .info-value {
            font-weight: 700;
            font-size: 11px;
            color: #000;
          }
          
          /* Room Tasks Table - PROMINENT */
          .tasks-section {
            margin-bottom: 10px;
          }
          
          .tasks-title {
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: black;
            padding: 8px;
            margin-bottom: 0;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          
          .tasks-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 0;
            font-size: 10px;
          }
          
          .tasks-table th {
            background:rgb(253, 178, 243);
            color: black;
            padding: 4px 3px;
            text-align: left;
            font-weight: 400;
            font-size: 12px;
            text-transform: uppercase;
            border: 1px solid #000;
          }
          
          .tasks-table td {
            padding: 4px 3px;
            border: 1px solid #333;
            vertical-align: center;
            font-size: 13px;
            line-height: 1;
          }
          
          .tasks-table tr:nth-child(odd) td {
            background: white;
          }
          
          .tasks-table tr:nth-child(even) td {
            background:rgb(223, 223, 223);
          }
          
          .room-cell {
            width: 10px;
            text-align: left;
            font-weight: 700;
            font-size: 16px;
          }
          
          .task-desc-cell {
            width: 10px;
            font-weight: 300;
          }
          
          .notes-cell {
            width: content-box;
            font-size: 12px;
            white-space: pre-line;
          }
          
          .worker-cell {
            width: 20px;
          }
          
          .date-cell {
            width: 5px;
            text-align: right;
          }

          .status-cell {
            width: 15px;
            text-align: center;
            font-weight: 600;
            font-size: 11px;
          }

          /* Wig Specifications - Compact */
          .wig-specs-section {
            margin-top: 15px;
          }
          
          .wig-specs-title {
            font-size: 14px;
            font-weight: 700;
            color: black;
            padding: 6px 10px;
            margin-bottom: 0;
            text-transform: uppercase;
          }

          .wig-specs-badges {
            border: 1px solid #333;
            padding: 12px;
            background: white;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            align-items: flex-start;
          }

          .spec-badge {
            display: inline-flex;
            align-items: center;
            border: 1px solid #dee2e6;
            border-radius: 15px;
            padding: 4px 10px;
            font-size: 9px;
            white-space: nowrap;
          }

          .badge-label {
            font-weight: 600;
            color: #495057;
            margin-right: 4px;
          }

          .badge-value {
            font-weight: 700;
            color: #000;
          }
         /* Footer */
          .worksheet-footer {
            margin-top: 10px;
            text-align: center;
            padding-top: 10px;
            border-top: 2px solid #000;
            font-size: 10px;
            font-weight: 600;
          }
          
          /* Hide modal elements for print */
          .worksheet-modal-overlay {
            background: none !important;
            backdrop-filter: none !important;
          }
          
          .worksheet-modal {
            box-shadow: none !important;
            border-radius: 0 !important;
            width: 100% !important;
            max-width: none !important;
            max-height: none !important;
            margin: 0 !important;
          }
          
          .worksheet-modal-header {
            display: none !important;
          }
          
          .worksheet-modal-body {
            padding: 0 !important;
            overflow: visible !important;
            max-height: none !important;
          }

          
          .qr-code {
            border-radius: 4px;
            padding: 2px;
            background: white;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0; /* Prevent QR code from shrinking */
          }

          .qr-code img {
            display: block;
            border-radius: 2px;
          }

          .barcode-date-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
          }
        </style>
`;

  // Format status as symbol
  const formatStatusSymbol = (status) => {
    if (!status) return '-';
    const statusLower = status.toLowerCase();

    // Completed statuses
    if (statusLower.includes('complete') || statusLower.includes('done')) {
      return '✓';
    }
    // Not started statuses
    if (statusLower.includes('not started') || statusLower === 'new') {
      return '✗';
    }
    // In progress, pending, on hold statuses
    return '-';
  };

  // Sort tasks by status and room priority
  export const sortTasks = (tasks) => {
    return [...tasks].sort((a, b) => {
      const roomNoA = a.RoomNo || a.roomNo;
      const roomNoB = b.RoomNo || b.roomNo;
      const roomNameA = String(roomNoA || '').toLowerCase();
      const roomNameB = String(roomNoB || '').toLowerCase();

      // Define special room priorities (lower number = higher priority)
      const getRoomPriority = (roomNo, roomName) => {
        // Check by room number first (prep rooms)
        if (roomNo === 9001 || roomNo === 20001 || roomNo === 31001 || roomNo === '9001' || roomNo === '20001' || roomNo === '31001') {
          return 0;  // Prep rooms always first
        }
        // Check by room name
        if (roomName.includes('wig prep') || roomName.includes('prep room')) return 0;  // Always first
        if (roomName.includes('quality control')) return 998;  // Second to last
        if (roomName.includes('customer pickup')) return 999;  // Always last
        return 500;  // Normal priority
      };

      const roomPriorityA = getRoomPriority(roomNoA, roomNameA);
      const roomPriorityB = getRoomPriority(roomNoB, roomNameB);

      // If one of the rooms has special priority, sort by that
      if (roomPriorityA !== roomPriorityB) {
        return roomPriorityA - roomPriorityB;
      }

      // For non-special rooms, sort by status
      const statusA = formatStatusSymbol(a.TaskStatus || '');
      const statusB = formatStatusSymbol(b.TaskStatus || '');

      // Define status priority (lower number = higher priority)
      const getStatusPriority = (symbol) => {
        if (symbol === '✓') return 1;  // Completed on top
        if (symbol === '-') return 2;  // In progress in middle
        if (symbol === '✗') return 3;  // Not started at bottom
        return 4;
      };

      return getStatusPriority(statusA) - getStatusPriority(statusB);
    });
  };

  // Format date consistently
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  // Format notes with line breaks for display
  const formatNotesForDisplay = (notes) => {
    if (!notes) return '';
    // Split by \n and create array of text segments
    const lines = notes.split(/\\n/);
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

const LegacyWorksheetSheet = forwardRef(({ orderDetails, customerInfo, wigDetails, roomTasks: enhancedRoomTasks }, ref) => (
          <div ref={ref} className="worksheet-container">
           {/* Key Information Header */}
          <div className="key-info-header">
            <div className="key-info-left">
              <div className="customer-name">
                {customerInfo?.customerName || orderDetails?.orderCustomerName || 'N/A'}
              </div>
              <div className="order-number">
                ORDER #{orderDetails?.orderNo || 'N/A'}
              </div>
                <div className="barcode">
                 WIGCODE:  {orderDetails?.wigBarCode || orderDetails?.orderNo || 'N/A'}
                </div>
                <span className="info-value">Order Date: {formatDate(orderDetails?.orderDate)}</span>
                 <span className="info-value">DUE DATE: {formatDate(orderDetails?.dueDate)}</span>
            </div>
            <div className="key-info-right">
               <div className="key-info-left">
              <span className="info-value">
                Phone: {customerInfo?.phone || orderDetails?.orderPhone || 'N/A'}
                </span>
              <div className="info-value">
                Mold ID: {orderDetails?.moldId || customerInfo?.moldId || 'N/A'}
                </div>
                  <span className="info-value">Order Type:{orderDetails?.orderType || 'N/A'} </span>
                
             
               </div>
           

            </div>

        
          </div>
                  

        
          
            {/* PROMINENT Room Tasks Section */}
            <div className="tasks-section">
              <div className="tasks-title">
                PRODUCTION ROOM ROUTING & TASKS
              </div>
              
              <table className="tasks-table">
                <thead>
                  <tr>
                    <th className="room-cell">ROOM</th>
                    <th className="task-desc-cell">TASK</th>
                    <th className="notes-cell">TASK NOTES</th>
                    <th className="notes-cell">QC NOTES</th>
                    <th className="worker-cell">WORKER</th>
                    <th className="date-cell">DUE DATE</th>
                    <th className="status-cell">STATUS</th>
                  </tr>
                </thead>
                <tbody>
                {enhancedRoomTasks && enhancedRoomTasks.length > 0 ? (
                  sortTasks(
                    enhancedRoomTasks.filter(task => {
                      // Filter out tasks with rejected status
                      const status = (task.TaskStatus || '').toLowerCase();
                      return !status.includes('reject');
                    })
                  ).map((task, index) => (
                      <tr key={`task-${index}`}>
                        <td className="room-cell">{task.RoomNo || task.roomNo || ''}</td>
                        <td className="task-desc-cell">
                          {/* <strong>{task.roomDescription || task.RoomDescription || ''}</strong> */}

                          <small>{task.RoomTask || task.roomTask || task.taskDescription || ''}</small>
                        </td>
                        <td className="notes-cell">{formatNotesForDisplay(task.TaskNotes || task.taskNotes || '')}</td>
                        <td className="notes-cell">{formatNotesForDisplay(task.QC_Notes || task.qcNotes || '')}</td>
                        <td className="worker-cell">{task.AssignedWorker || task.assignedWorker || task.UserName || ''}</td>
                        <td className="date-cell">
                          {task.TaskDueDate ? formatDate(task.TaskDueDate) : (task.taskDueDate ? formatDate(task.taskDueDate) : (task.DueDate ? formatDate(task.DueDate) : ''))}
                        </td>
                        <td className="status-cell">{formatStatusSymbol(task.TaskStatus)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: '#666', fontStyle: 'italic' }}>
                        No production tasks assigned yet
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Wig Build Specifications - Compact */}
            {(orderDetails?.orderType !== 'Consultation' && orderDetails?.orderType !== 'Accessory') && (
              <div className="wig-specs-section">
                <div className="wig-specs-title">
                  WIG BUILD SPECIFICATIONS
                </div>
                
                <div className="wig-specs-badges">
                  <div className="spec-badge">
                    <span className="badge-label">Base Color:</span>
                    <span className="badge-value">{formatColorName(wigDetails?.baseColor || orderDetails?.baseColor) || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Wig Type:</span>
                    <span className="badge-value">{wigDetails?.wigType || orderDetails?.wigType || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Hair Length:</span>
                    <span className="badge-value">{wigDetails?.hairLength || orderDetails?.wigLength || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Hair Type:</span>
                    <span className="badge-value">{wigDetails?.hairType || orderDetails?.hairType || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Net Size:</span>
                    <span className="badge-value">{wigDetails?.netSize || orderDetails?.netSize || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Net Type:</span>
                    <span className="badge-value">{wigDetails?.netType || orderDetails?.netType || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Lace Type:</span>
                    <span className="badge-value">{wigDetails?.laceType || orderDetails?.laceType || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Top Size:</span>
                    <span className="badge-value">{wigDetails?.topSize || orderDetails?.topSize || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Wig Code:</span>
                    <span className="badge-value">{orderDetails?.wigSerialNo || orderDetails?.wigSerialCode || 'N/A'}</span>
                  </div>
                  <div className="spec-badge">
                    <span className="badge-label">Measurements:</span>
                    <span className="badge-value">
                      {[
                        wigDetails?.hairlineToCrown || orderDetails?.hairlineToCrown,
                        wigDetails?.hairlineToNape || orderDetails?.hairlineToNape,
                        wigDetails?.earToEar || orderDetails?.earToEar
                      ].filter(Boolean).join(' | ') || 'N/A'}
                    </span>m
                  </div>

                 
                  <div className="spec-badge">
                    <span className="badge-label">Wig Weight</span>
                    <span className="badge-value">{wigDetails?.wigWeight !== undefined ? `${wigDetails.wigWeight}g` : 
                   orderDetails?.wigWeight !== undefined ? `${orderDetails.wigWeight}g` : 'N/A'}</span>
                  </div>
             
                </div>
              </div>
            )}

            {/* Footer */}
            <div className="worksheet-footer">
              <strong>DINI WIGS PRODUCTION WORKSHEET</strong> |
              Order #{orderDetails?.orderNo} |
              Generated: {new Date().toLocaleString('en-US', {
                timeZone: 'America/New_York',
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
              })} EST |
              WigCode: {orderDetails?.wigBarCode || orderDetails?.orderNo || 'N/A'}
            </div>

          </div>
));

LegacyWorksheetSheet.displayName = 'LegacyWorksheetSheet';

export default LegacyWorksheetSheet;
